import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'RedGirasol';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    buildParametersConfig: {
        extendParameters: (baseParameters, values, parameters) => {
            const { blind_objects, hitch, is_percentage, terms } =
                baseParameters;
            const { dealer_fee } = parameters;

            return {
                blind_objects,
                dealer_fee,
                hitch,
                is_percentage,
                terms,
            };
        },
    },
    buildPayloadConfig: {
        extendPayload: (basePayload, values) => ({
            ...basePayload,
            api_key: 'api_key',
            secret_key: 'secret_key',
            type_proposal_template: values.type_proposal_template,
        }),
    },
    buildPrepareValuesConfig: {
        extendPrepareValues: (baseValues, values) => ({
            ...baseValues,
            type_proposal_template: values.type_proposal_template || '',
        }),
    },
    customAlgorithms: [{ label: 'API Key', value: 'static_api_key' }],
    name,
    validationConfig: { schema: validate },
});

export default { ...config, name };
